import { analiticaInstance as analiticaInstanceConfigs } from './analitica.configs';
import { DigitalWalletsType } from './analitica.types';

export type StatusPagePaymentMethod = 'credito' | 'debito' | 'pix' | 'boleto';

export type StatusPageStatus =
  | 'aguardando_pagamento'
  | 'expirado'
  | 'em_analise'
  | 'pago'
  | 'recusado';

export interface StatusPageViewedParams {
  paymentMethod: StatusPagePaymentMethod;
  status: StatusPageStatus;
  digitalWallet?: DigitalWalletsType;
}

const AMPLITUDE_ONLY = ['AMPLITUDE_CHECKOUT_V3'];

const amplitudeOnly = <T extends { label: string; metadata?: object }>(
  event: T
) => ({ ...event, filterPlugins: AMPLITUDE_ONLY });

export const analiticaStatusPageEvents = analiticaInstanceConfigs.eventFactory(
  'Checkout v3',
  {
    statusPage: {
      pageViewed: ({ paymentMethod, status, digitalWallet }: StatusPageViewedParams) => ({
        label: 'page-viewed',
        metadata: {
          screen: 'status_pedido',
          reference: 'tela',
          payment_method: paymentMethod,
          status,
          ...(digitalWallet ? { digital_wallet: digitalWallet } : {}),
          description: 'Visualização da tela de status do pedido',
        },
      }),
      copyPixCodeClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_copiar_codigo_pix',
          description: 'Clique no botão Copiar código pix',
        },
      }),
      copyBoletoCodeClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_copiar_codigo_boleto',
          description: 'Clique no botão Copiar código de barras do boleto',
        },
      }),
      downloadBoletoClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_baixar_boleto',
          description: 'Clique no botão Baixar boleto',
        },
      }),
      downloadReceiptClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_baixar_comprovante',
          description: 'Clique no botão Baixar comprovante',
        },
      }),
      trackPackageClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_rastrear_pedido',
          description: 'Clique no botão Rastrear pedido',
        },
      }),
      backToStoreClicked: () => amplitudeOnly({
        label: 'button-clicked',
        metadata: {
          screen: 'status_pedido',
          reference: 'botao_voltar_loja',
          description: 'Clique no botão Voltar para a loja',
        },
      }),
    },
  }
);
